module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_car_73cc2b43406f23b72d0aeb57d7e3bf3c.png";